<template>
    <div class="industry main_width m_0">
        <div class="title">
            <span>1000+</span>
            个行业品牌都在使用汽修宝 
        </div>
        <img src="../../../static/images2/cooperation_icon.png" alt="">
    </div>
</template>
<script>
export default {
  name: "industry"
};
</script>
<style lang="less" scoped>
@import "../../assets/style/utils.less";
.industry {
    padding: .px2vw(48)[@result] .px2vw(37)[@result] 0;
    box-sizing: border-box;
    text-align: center;
    .title {
        font-weight: 700;
        font-size: .px2vw(32)[@result];
        margin-bottom: .px2vw(32)[@result];
        span {
            color: #165DFF;
        }
    }
    img {
        max-width: 62.5vw;
        max-height: .px2vw(454)[@result];
        object-fit: cover;
    }
}

@media screen and (max-width: 900px) {
    .industry {
        padding: .h5px2vw(32)[@result] .h5px2vw(24)[@result] 0;
        .title {
            font-size: .h5px2vw(32)[@result];
            margin-bottom: .h5px2vw(24)[@result];
        }
        img {
            max-width: 100%;
            max-height: .h5px2vw(266)[@result];
            object-fit: cover;
        }
    }
}
</style>


// WEBPACK FOOTER //
// src/pages/index/industry.vue